<template>
  <v-dialog v-model="visible" max-width="600px" persistent>
    <v-card class="mb-0">
      <v-card-title class="headline">
        <v-icon left>mdi-account-star-outline</v-icon>
        Asignar jugadores a equipos
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              large
              color="indigo"
              @click="inscripciones"
              v-on="on"
              class="ml-1"
            >
              <v-icon large>mdi-format-list-numbered</v-icon>
            </v-btn>
          </template>
          <span>Lista de Inscriptos</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent ref="form">
          <v-row class="mt-4">
            <v-col cols="12">
              <!-- <h2 class="mb-4">Elegir jugadores desde:</h2> -->
              <!-- <v-btn-toggle
                v-model="jugadoresSource"
                tile
                color="deep-purple accent-3"
                group
                disabled
              >
                <v-btn value="inscriptos"> Inscriptos </v-btn>

                <v-btn value="todos"> Todos los jugadores </v-btn>
              </v-btn-toggle> -->
              <span class="inscriptos"
                >EN LA LISTA SE MUESTRAN SOLO JUGADORES INSCRIPTOS</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3 class="mb-4">Jugador 1</h3>
              <v-autocomplete
                :items="jugadores"
                v-model="jugador1"
                item-text="nombreJugador"
                item-value="idJugador"
                label="Jugador 1"
                dense
                prepend-icon="mdi-account-star-outline"
                :no-data-text="
                  jugadoresSource === 'todos'
                    ? 'No hay jugadores registrados'
                    : 'No hay jugadores inscriptos al torneo disponibles para seleccionar'
                "
                return-object
                chips
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="tipoCompetencia === 'Dobles'" class="mt-4">
            <v-col cols="12">
              <h3 class="mb-4">Jugador 2</h3>
              <v-autocomplete
                :items="jugadores"
                v-model="jugador2"
                item-text="nombreJugador"
                item-value="idJugador"
                label="Jugador 2"
                dense
                prepend-icon="mdi-account-star-outline"
                :no-data-text="
                  jugadoresSource === 'todos'
                    ? 'No hay jugadores registrados'
                    : 'No hay jugadores inscriptos al torneo disponibles para seleccionar'
                "
                return-object
                chips
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar" color="grey" dark>Cancelar</v-btn>
        <v-btn
          :disabled="!jugador1 || (tipoCompetencia === 'Dobles' && !jugador2)"
          @click="guardar"
          color="success"
          >Guardar cambios</v-btn
        >
      </v-card-actions>
    </v-card>
    <lista-inscriptos
      :visible="modalInscripciones"
      :idTorneo="idTorneo"
      :infoTorneo="infoTorneo"
      :sistemaCompetencia="sistemaCompetencia"
      @close="cierraListaInscriptos"
    />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import axios from "@/axios-auth";
import ListaInscriptos from "./ListaInscriptos.vue";
import { showAlert } from "@/utils/toast";

interface Jugador {
  idJugador: number;
  nombreJugador: string;
}

export default defineComponent({
  name: "AsignarJugadores",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    tipoCompetencia: {
      type: String,
      required: true,
    },
    proxy: {
      type: Object,
      default: null,
    },
    idTorneo: {
      type: [Number, String],
    },
    ids: {
      type: Object,
    },
    infoTorneo: {
      type: String,
    },
    idsUsados: {
      type: Array,
    },
    sistemaCompetencia: {
      type: String,
      default: "Torneo",
    },
  },

  components: { ListaInscriptos },

  emits: ["close", "save"],

  setup(props, { emit }) {
    const jugadoresSource = ref("inscriptos");

    const jugador1 = ref<Jugador | null>(null);
    const jugador2 = ref<Jugador | null>(null);

    const jugadores = ref([]);

    const modalInscripciones = ref(false);

    const buscarTodosJugadores = async () => {
      const filtrosData = {
        idInstitucion:
          props.proxy.$store.state.usuario.institucion.idInstitucion,
        page: 1,
        items: 9999999,
        dni: "",
        apellidos: "",
        nombres: "",
        esGestante: "todos",
        esDiabetico: "todos",
        esEpoc: "todos",
        esFumador: "todos",
        esHta: "todos",
        esObeso: "todos",
        esRcv: "todos",
        esSobrePeso: "todos",
      };
      try {
        const { data } = await axios.post(
          "/Paciente/BuscarPacientes?",
          filtrosData,
        );
        jugadores.value = data.listaPacientes.map((jugador: any) => {
          return {
            ...jugador,
            nombreJugador: jugador.apellidos + ", " + jugador.nombres,
            idJugador: jugador.idpaciente,
          };
        });
      } catch (error) {
        jugadores.value = [];
        console.log(error);
      }
    };

    const buscarJugadores = async (idTorneo: any) => {
      try {
        const { data } = await axios.get("/Torneos/GetInscriptos", {
          params: {
            idTorneo: idTorneo,
          },
        });
        jugadores.value =
          data.filter((jugador: any) => {
            const idJugador = jugador.idJugador;
            const estaUsado = props.idsUsados?.includes(idJugador);

            return !estaUsado;
          }) || [];
      } catch (error) {
        jugadores.value = [];
      }
    };

    const cerrar = () => {
      emit("close");
    };

    const inscripciones = (torneo: any) => {
      modalInscripciones.value = true;
    };

    const vaciarCampos = () => {
      jugador1.value = null;
      jugador2.value = null;
    };

    const guardar = () => {
      if (
        props.tipoCompetencia === "Dobles" &&
        jugador1.value?.idJugador === jugador2.value?.idJugador
      ) {
        showAlert({
          icon: "warning",
          title: "No puede elegir el mismo jugador 2 veces.",
          timer: 2500,
          vm: props.proxy,
        });
        return;
      }
      emit("save", {
        jugador1,
        jugador2,
      });
      vaciarCampos();
    };

    const cierraListaInscriptos = () => {
      buscarJugadores(props.idTorneo);
      modalInscripciones.value = false;
    };

    watch(
      () => props.idTorneo,
      async (value) => {
        await buscarJugadores(value);
      },
      { immediate: true },
    );

    watch(
      [() => props.ids, () => jugadores.value],
      ([ids]) => {
        if (!ids || jugadores.value.length === 0) {
          jugador1.value = null;
          jugador2.value = null;
          return;
        }

        jugador1.value =
          jugadores.value.find((j: any) => j.idJugador === ids.idJugador1) ||
          null;

        jugador2.value =
          jugadores.value.find((j: any) => j.idJugador === ids.idJugador2) ||
          null;
      },
      { immediate: true },
    );

    return {
      cerrar,
      guardar,
      jugadoresSource,
      jugador1,
      jugador2,
      jugadores,
      modalInscripciones,
      inscripciones,
      cierraListaInscriptos,
    };
  },
});
</script>

<style>
.modal {
  background: white;
  padding: 16px;
  border-radius: 8px;
  min-width: 320px;
}
.modal-actions {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-top: 12px;
}
.grid {
  display: grid;
  grid-template-columns: 80px 1fr 1fr 40px;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.header-grid {
  margin-bottom: 1rem;
  font-weight: bold;
}

.team-label {
  text-align: center;
}

.row-grid input {
  width: 70px;
  padding: 4px 6px;
}

.trash-icon {
  cursor: pointer;
  color: #ef4444;
  font-size: 18px;
  text-align: center;
}

.trash-icon:hover {
  transform: scale(1.1);
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 12px;
}
.inscriptos {
  height: 48px;
  color: #651fff;
  background-color: rgb(213, 200, 240);
  padding: 8px 16px;
}
</style>
